import { vatRate, mainVat, subVat } from './tax-data.js';

document.addEventListener("DOMContentLoaded", function () {
  if (subVat != '') {
    document.querySelectorAll('.js-tax-price').forEach((element, index) => {
      let dataPrice = element.getAttribute("data-price"); // Get price directly from each product
    
      if (!dataPrice || dataPrice === "0") return; // Skip if no price found

      let taxPrice = Number(dataPrice) / Number(vatRate); // Convert to Ex VAT
      let decimalPrice = (taxPrice / 100).toFixed(2); // Format to 2 decimal places
      let moneyPrice = decimalPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let exVatPrice = `€${moneyPrice} ${subVat}`;

      // Apply the correct price inside its respective `.js-tax-price`
      element.innerHTML = exVatPrice;
    });
  }
  document.querySelectorAll('.js-main-price-text').forEach((element, index) => {
    let dataPrice = element.getAttribute("data-price"); // Get price directly from each product
    console.log(dataPrice);
    if (dataPrice != '0'){
      element.innerHTML = mainVat;
    }
  });
});



//This is the code that is used when a shopify product variant is picked
function variantTaxPrice() {
  if (subVat != '') {
    document.querySelectorAll('.js-tax-price').forEach((element, index) => {
      let dataPrice = element.getAttribute("data-price"); // Get price directly from each product
    
      if (!dataPrice || dataPrice === "0") return; // Skip if no price found

      let taxPrice = Number(dataPrice) / Number(vatRate); // Convert to Ex VAT
      let decimalPrice = (taxPrice / 100).toFixed(2); // Format to 2 decimal places
      let moneyPrice = decimalPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let exVatPrice = `€${moneyPrice} ${subVat}`;

      // Apply the correct price inside its respective `.js-tax-price`
      element.innerHTML = exVatPrice;
    });
  }
  document.querySelectorAll('.js-main-price-text').forEach((element, index) => {
    let dataPrice = element.getAttribute("data-price"); // Get price directly from each product
    console.log(dataPrice);
    if (dataPrice != '0'){
      element.innerHTML = mainVat;
    }
  });
};

window.variantTaxPrice = variantTaxPrice;